<!-- footer -->
<div class="footer-cpy text-center">
    <!-- <div class="social_banner">
        <ul class="social_list">
            <li>
                <a href="https://www.facebook.com/FareBoutiqueB2B" target="_blank" class="facebook">
                    <span class="fa fa-facebook" aria-hidden="true"></span>
                </a>
            </li>
            <li>
                <a href="https://twitter.com/FareBoutique" target="_blank" class="twitter">
                    <span class="fa fa-twitter" aria-hidden="true"></span>
                </a>
            </li>
        </ul>
    </div> -->
    <!-- <div class="mb-2 mt-3" style="font-size:13px;"><span class="mr-2" style="color:#fff;cursor: pointer;"
            routerLink="/homepage/aboutus">About Us</span> | <span class="mr-2" style="color:#fff;cursor: pointer;"
            routerLink="/homepage/contactus">Contact Us</span> | <span class="mr-2" style="color:#fff;cursor: pointer;"
            routerLink="/homepage/termscondition">Terms & Condition</span> | <span style="color:#fff;cursor: pointer;"
            routerLink="/homepage/privacypolicy">Privacy Policy</span></div> -->
    <div class="footer-copy m-0 ft-12">
        <p style="margin:0px;">Copyright © {{anio}} All rights reserved to {{titleFooter}} Services.
        </p>
    </div>
</div>
<!--//footer-->